import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { TweenMax } from 'gsap';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/dg200/');

export default function CardImgL() {
    const { useLang, isMobile, useEffect } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    const textFadeInOut = (el: any) => {
        const target = `.dg200 .cardImgL ${el}`;
        const targetEl = document.querySelector(target) as HTMLElement;
        const targetH = targetEl?.offsetHeight || 100;

        const scene1 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: 0,
            triggerHook: 1,
            duration: targetH,
        });
        const tween1 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 0 });
        scene1.setTween(tween1);
        scene1.addTo(controller);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: targetH,
            triggerHook: 1,
            duration: targetH,
        });
        const tween2 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 1 });
        scene2.setTween(tween2);
        scene2.addTo(controller);

        const scene3 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: isMobile ? '-.44rem' : '-60px',
            triggerHook: 0,
            duration: targetH,
        });
        const tween3 = TweenMax.fromTo(target, 0.5, { opacity: 1 }, { opacity: 0 });
        scene3.setTween(tween3);
        scene3.addTo(controller);
    };

    useEffect(() => {
        if (!isMobile) {
            textFadeInOut('.title');
        }
    }, []);

    return (
        <div className={`cardImgL ${css.cardImgL} ${isMobile ? 'cardImgL_h5' : 'cardImgL_pc'}`}>
            <div className="box">
                <div className="title">{t('dg200.cardImgL_title')}</div>
                <div className="imgs">
                    <div className="imgBox">
                        <EFPic
                            name={[`${isMobile ? 'h5/' : 'pc/'}12_1.webp`, `${isMobile ? 'h5/' : 'pc/'}12_1.png`]}
                            // layout="fill"
                            className="fullImgs"
                            alt={t('dg200.cardImgL_img1_text')}
                            aria-label={t('dg200.cardImgL_img1_text')}
                        />
                        <p className="text">{t('dg200.cardImgL_img1_text')}</p>
                    </div>
                    <div className="imgBox">
                        <EFPic
                            name={[`${isMobile ? 'h5/' : 'pc/'}12_2.webp`, `${isMobile ? 'h5/' : 'pc/'}12_2.png`]}
                            // layout="fill"
                            className="fullImgs"
                            alt={t('dg200.cardImgL_img2_text')}
                            aria-label={t('dg200.cardImgL_img2_text')}
                        />
                        <p className="text">{t('dg200.cardImgL_img2_text')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
